import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { TagColor } from "app/data/common/tagColor";
import { formatDate } from "features/freights/utils/utils";
import TerminalDetails from "ui-components/terminal-details/terminalDetails";
import Tag from "ui-components/molecules/tag/tag";
import _ from "lodash";
import XGSNavLink from "ui-components/xgs-nav-link/xgsNavLink";

const columnHelper = createColumnHelper<any>();

const getStatusColor = (status: string) => {
  if (status === 'ARRIVED') {
    return TagColor.GREEN;
  }
  if (status === 'LATE') {
    return TagColor.ORANGE;
  }
  if (status === 'ALERT') {
    return TagColor.RED;
  }
  if (status === 'INBOUND') {
    return TagColor.YELLOW;
  }
  else
    return TagColor.GREY;
}

const getArrivalStatus = (status: string) => {
  if (status === 'ARRIVED') {
    return "Actual Arrival only";
  }
  if (status === 'LATE') {
    return "Expected (Late)";
  }
  if (status === 'INBOUND') {
    return "ETA only";
  }
}

export const getInboundFreightsColumn = () => [
  columnHelper.accessor("manifestNumber", {
    id: "manifestNumber",
    header: "Manifest",
    cell: (props) => {
      const manifestNumber = props.getValue();
      if (!manifestNumber) return '-';
      return (
        <XGSNavLink
          className="xgs-table-link-cell"
          to={`/shipments?lm=${manifestNumber}`}
        >
          {manifestNumber}
        </XGSNavLink>
      );
    },
    size: 80,
    minSize: 80,
  }),

  columnHelper.accessor("status", {
    id: "status",
    header: "Status",
    cell: (props) => {
      return <>
        <Tag mods={{ color: getStatusColor(props.getValue() ?? '') }}>
          {props.getValue() ?? '-'}
        </Tag>
      </>
    },
    size: 90,
    minSize: 90,
  }),

  columnHelper.accessor("trailerNumber", {
    id: "trailerNumber",
    header: "Trailer",
    cell: (props) => !_.isEmpty(props.getValue()) ? props.getValue()?.toString() : '-',
    size: 80,
    minSize: 80,
  }),

  columnHelper.accessor("originCity", {
    id: "originCity",
    header: "Origin Terminal",
    cell: (cellProps) => {
      return <><TerminalDetails terminalName={cellProps.getValue()?.toString().toUpperCase() || ""} />
      </>
    }, size: 120,
    minSize: 120,
  }),
  columnHelper.accessor(
    "originDate",
    {
      id: "originDate",
      header: "Dispatch Date",
      cell: (props) => {
        return <>
          {!_.isEmpty(props.getValue()) ? props.getValue()?.toString() : '-'}
        </>
      },
      size: 80,
      minSize: 80,
    }
  ),

  columnHelper.accessor(
    (row) => ({
      arrivalDate: row.arrivalDate,
      arrivalTime: row.arrivalTime,
    }),
    {
      id: "arrivalEta",
      header: "Arrival / ETA",
      cell: ({ getValue, row }) => {
        const { arrivalDate, arrivalTime } = getValue();
        return <>{formatDate(`${arrivalDate} ${arrivalTime}`)}
          <div style={{ fontSize: '12px', color: '#777' }}>
            {getArrivalStatus(row?.original?.status ?? '')}
          </div></>;
      },

      size: 120,
      minSize: 120,
    }
  ),

  columnHelper.accessor("probillCount", {
    id: "probillCount",
    header: "Probills",
    cell: (props) => !_.isEmpty(props.getValue()) ? props.getValue() : '-',
    size: 70,
    minSize: 70,
  }),

  columnHelper.accessor("piecesCount", {
    id: "piecesCount",
    header: "Pieces",
    cell: (props) => !_.isEmpty(props.getValue()) ? props.getValue() : '-',
    size: 80,
    minSize: 80,
  }),

  columnHelper.accessor("lbs", {
    id: "lbs",
    header: "Weight(lbs)",
    cell: (props) => props.getValue() ? Number(props.getValue())?.toLocaleString("en-US") : '-',
    size: 80,
    minSize: 80,
  }),
];
